import { Button } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { Icon, Segment } from 'semantic-ui-react';

import { useAppSettings } from 'settings';
import { BulkDataType } from 'types';

interface TemplateSegmentProps {
  templateKey: BulkDataType;
}

export const TemplateSegment = ({ templateKey }: TemplateSegmentProps) => {
  const appSettings = useAppSettings();
  const templateUrl = appSettings?.bulkUploadLinks?.[templateKey];

  return (
    <Segment>
      <h4>Template</h4>

      <Button as="a" basic fluid color="green" href={templateUrl} disabled={!templateUrl} icon>
        Download
        <S.Icon name="download" />
      </Button>
    </Segment>
  );
};

const S = {
  Icon: styled(Icon)`
    .ui.icon.button > &.icon {
      margin-left: 0.5em !important;
    }
  `,
};
